import { useQuery } from '@tanstack/react-query';
import { TreatmentService, treatmentKeys } from '@client/services/treatmentService';

export const useTreatment = (identifier, options = {}) => {
  return useQuery({
    queryKey: treatmentKeys.detail(identifier),
    queryFn: () => TreatmentService.getTreatment(identifier),
    enabled: !!identifier,
    ...options,
  });
};

export const useTreatments = (filters = {}, options = {}) => {
  return useQuery({
    queryKey: treatmentKeys.filter(filters),
    queryFn: () => TreatmentService.filterTreatments(filters),
    ...options,
  });
};

export const useTreatmentCultureTree = (treatmentId, params = {}, options = {}) => {
  return useQuery({
    queryKey: treatmentKeys.cultureTree(treatmentId, params),
    queryFn: () => TreatmentService.getCultureTree(treatmentId, params),
    enabled: !!treatmentId && options.enabled !== false,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};